import type { TFunction } from 'i18next';

export const BOX_NAME_MAX_LENGTH = 40;
export type NamePresetGroupId = 'close' | 'work' | 'halloween';

/** Arrays are owned by the locale; removing a name needs no code change. */
export function nameSuggestions(t: TFunction, group: NamePresetGroupId, year: number): string[] {
  const result: unknown = t(`newBox.nameSuggestions.${group}`, {
    year,
    returnObjects: true,
    defaultValue: [],
    fallbackLng: false,
  });
  if (!Array.isArray(result)) return [];
  return [
    ...new Set(
      result
        .filter((name): name is string => typeof name === 'string')
        .map((name) => name.trim())
        .filter((name) => name.length > 0 && name.length <= BOX_NAME_MAX_LENGTH),
    ),
  ];
}
